module.exports = __webpack_public_path__ + "static/media/ford.d91c016c.svg";